var map = {
	"./0.png": 166068,
	"./1.png": 387197,
	"./2.png": 319782,
	"./3.png": 88527,
	"./4.png": 492656,
	"./5.png": 208409,
	"./6.png": 694402,
	"./7.png": 458059,
	"./8.png": 277756,
	"./9.png": 595269,
	"./dian.png": 157478
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 536983;